/**
 * 리버스 프록시로 서빙되는 별도 host 목록.
 * 제휴사 사내망에서 usimsa.com(Vercel IP)이 차단되어 만든 도메인이라,
 * 이 host로 들어온 사용자는 리다이렉트/콜백도 같은 host를 유지해야 한다.
 */
const PROXY_HOSTS = ['partners.usimsa.com']

/** 현재 접속한 host가 프록시 전용 도메인인지 */
export const useIsProxyHost = () => PROXY_HOSTS.includes(useRequestURL().hostname)

/**
 * 리다이렉트/콜백 URL을 만들 때 쓸 baseUrl.
 * 프록시 전용 도메인으로 접속한 경우에만 현재 origin을 쓰고, 그 외에는 설정값을 그대로 쓴다.
 *
 * 주의: 운영에서 config.public.baseUrl은 https://usimsa.com 인데 실제 접속 host는
 * https://www.usimsa.com 이다(apex→www 308 리다이렉트). 즉 두 값은 원래 다르므로
 * "origin이 baseUrl과 다르면 바꾼다"는 식으로 판단하면 메인 사이트의 콜백 URL까지
 * www 붙은 주소로 바뀌어 SNS 로그인이 깨진다. 반드시 host 목록으로만 판단할 것.
 */
export const useCurrentBaseUrl = () => {
  const config = useRuntimeConfig()

  return useIsProxyHost() ? useRequestURL().origin : config.public.baseUrl
}

/**
 * 통합인증(my.usimsa.com)으로 넘길 때 복귀할 origin.
 * my 쪽은 referrer로도 복귀 origin을 판단하지만, 인앱 웹뷰 등에서 referrer가 비는
 * 경우가 있어 명시적으로 전달한다.
 * 프록시 도메인이 아니면 빈 문자열이라, 기존 URL과 동일하게 유지된다.
 */
export const useReturnOrigin = () => (useIsProxyHost() ? useRequestURL().origin : '')

/** useReturnOrigin을 쿼리스트링에 이어붙일 수 있는 `&returnOrigin=...` 조각으로 만든 것 */
export const useReturnOriginParam = () => {
  const origin = useReturnOrigin()

  return origin ? `&returnOrigin=${encodeURIComponent(origin)}` : ''
}

/** partnersKey를 쿼리스트링에 이어붙일 수 있는 `&partnersKey=...` 조각으로 만든 것 */
export const toPartnersKeyParam = (partnersKey?: string | null) =>
  partnersKey ? `&partnersKey=${encodeURIComponent(partnersKey)}` : ''
